import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type { FareSearchPayload, FareSearchResponse } from "../types/fare-search.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.inventory;

export const fareSearchService = {
  async search(payload: FareSearchPayload): Promise<FareSearchResponse> {
    try {
      return await apiClient<FareSearchResponse>(endpoints.fareSearch, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to search fares due to an unexpected error.",
        resData: null,
      };
    }
  },
};
